<template>
  <div class="container">
    <div class="container">
      <h2 class="payment-title">微信支付配置</h2>
      <a-form
        :model="wxPay"
        class="payment-form"
        :label-col="{ style: { width: '120px' } }"
      >
        <a-form-item label="AppId">
          <a-input
            v-model:value="wxPay.wx_pay_app_id"
            placeholder="请输入微信支付AppId"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="支付商户号">
          <a-input
            v-model:value="wxPay.wx_pay_merchant_id"
            placeholder="请输入支付商户号"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="证书序列号">
          <a-input
            v-model:value="wxPay.wx_pay_serial_no"
            placeholder="请输入证书序列号"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="微信支付公钥Id">
          <a-input
            v-model:value="wxPay.wx_pay_public_content_id"
            placeholder="请输入微信支付公钥Id"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="支付密钥">
          <a-input
            v-model:value="wxPay.wx_pay_key"
            placeholder="请输入支付密钥"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="支付回调地址">
          <a-input
            v-model:value="wxPay.wx_pay_notify_url"
            placeholder="请输入支付回调地址"
            class="payment-input"
          />
        </a-form-item>
        <a-form-item label="公钥证书">
          <div class="input-upload-wrapper">
            <a-input
              v-model:value="wxPay.wx_pay_public_key"
              placeholder="请输入公钥证书"
              class="custom-input"
            />
            <File-Upload v-model="wxPay.wx_pay_public_key" />
          </div>
        </a-form-item>
        <a-form-item label="私钥证书">
          <div class="input-upload-wrapper">
            <a-input
              v-model:value="wxPay.wx_pay_private_key"
              placeholder="请输入私钥证书"
              class="custom-input"
            />
            <File-Upload v-model="wxPay.wx_pay_private_key" />
          </div>
        </a-form-item>
        <a-form-item label="微信支付公钥证书">
          <div class="input-upload-wrapper">
            <a-input
              v-model:value="wxPay.wx_pay_public_content"
              placeholder="请输入私钥证书"
              class="custom-input"
            />
            <File-Upload v-model="wxPay.wx_pay_public_content" />
          </div>
        </a-form-item>
      </a-form>
      <div class="submit-button-wrapper">
        <a-button type="primary" @click="submitWxPay" class="submit-button"
          >提交修改
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from "vue";
import { ConfigService } from "@/api/services/ConfigService";
import { WxPay } from "@/api/models/config/WxPay";
import { message } from "ant-design-vue";
import { WxPayRequest } from "@/api/models/config/WxPayRequest";
import FileUpload from "@/components/FileUpload.vue";

const wxPay = reactive<WxPay>({});

const handleWxPay = async () => {
  const res = await ConfigService.WxPayGet();
  if (res.code === 0) {
    Object.assign(wxPay, res.data);
  } else {
    message.error(res.msg);
  }
};

const submitWxPay = async () => {
  const r: WxPayRequest = {};
  Object.assign(r, wxPay);
  const res = await ConfigService.WxPay(r);
  if (res.code === 0) {
    message.success("微信支付配置修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleWxPay();
});
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
  margin-bottom: 16px;
}

.payment-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 24px;
  text-align: left;
}

.payment-form {
  width: 100%;
}

.payment-input {
  margin-left: 4px;
}

.payment-form .ant-form-item-label > label {
  color: #555;
  font-weight: 500;
}

.payment-form .ant-input {
  border-radius: 6px;
  font-size: 14px;
  padding: 8px 12px;
}

.payment-form .ant-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.input-upload-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-input {
  width: 300px;
  margin-left: 4px;
}

.submit-button-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  margin-left: 80px; /* 调整左边距，与表单标签对齐 */
}

.submit-button {
  width: 150px;
  height: 40px; /* 调整按钮高度 */
  font-size: 16px; /* 调整按钮字体大小 */
}
</style>
